/**
 * @generated SignedSource<<292b4955709f0c3fa97867c035f92b08>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SettingsModal_viewer$data = {
  readonly activeDelegation: {
    readonly id: string;
  } | null;
  readonly " $fragmentType": "SettingsModal_viewer";
};
export type SettingsModal_viewer$key = {
  readonly " $data"?: SettingsModal_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"SettingsModal_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SettingsModal_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Delegation",
      "kind": "LinkedField",
      "name": "activeDelegation",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "960cefa04632e48e4903569c0638a5c8";

export default node;
